// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ModalVideo_wrapper__-HtHH","show":"ModalVideo_show__2ej2O","modal":"ModalVideo_modal__zxre9"};